const linkStatuses = {
  LINKED_TO_THIS: 'LINKED_TO_THIS',
  NOT_LINKED: 'NOT_LINKED',
  LINKED_TO_ANOTHER: 'LINKED_TO_ANOTHER',
};

const getLinkStatus = (link, itemId) => {
  if (link && link.id === itemId) return linkStatuses.LINKED_TO_THIS;
  if (link && link.id !== itemId) return linkStatuses.LINKED_TO_ANOTHER;
  return linkStatuses.NOT_LINKED;
};

export { linkStatuses, getLinkStatus };
